export const blockIconsMapsHomeWorkNew = (
	<span className='material-symbols-outlined'>home_work</span>
);
